/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var isObject = function isObject(obj) {
  return !Array.isArray(obj) && obj !== null && typeof obj === 'object';
};

export { isObject };
//# sourceMappingURL=is-object.js.map
